import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const useVehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [genericSavedMsg, setgenericSavedMsg] = useState("");

  // Fetch vehicles on mount
  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/vehicles`)
      .then(res => res.json())
      .then(data => setVehicles(data));
  }, []);

  // Add a new vehicle
  const addVehicle = async (vehicleData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/vehicles`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(vehicleData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al guardar el vehículo");
        return { error: result.error };
      }
      setVehicles(prev => [...prev, result]);
      setgenericSavedMsg("Vehículo guardado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al guardar el vehículo");
      return { error: "Error al guardar el vehículo" };
    }
  };

  // Edit an existing vehicle
  const editVehicle = async (vehicleData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/vehicles/${vehicleData.plate}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(vehicleData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al editar el vehículo");
        return { error: result.error };
      }
      setVehicles(prev =>
        prev.map(v => v.plate === vehicleData.plate ? result : v)
      );
      setgenericSavedMsg("Vehículo editado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setEditingVehicle(null);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al editar el vehículo");
      return { error: "Error al editar el vehículo" };
    }
  };

  // Remove (soft delete) a vehicle
  const removeVehicle = async (plate) => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este vehículo?")) return;
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/vehicles/${plate}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Error al eliminar el vehículo');
      setVehicles(prev => prev.filter(v => v.plate !== plate));
      setgenericSavedMsg("Vehículo eliminado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
    } catch (err) {
      setgenericSavedMsg("Error al eliminar el vehículo");
    }
  };

  return {
    vehicles,
    addVehicle,
    editVehicle,
    removeVehicle,
    editingVehicle,
    setEditingVehicle,
    genericSavedMsg
  };
};

export default useVehicles;